import * as React from "react";
import { ChapterSidebarProps } from "./chapter.types";
import { isStringArray } from "./chapter.helpers";
import { smoothScrollTo } from "../../utils/smooth-scroll-to";

export class ChapterSidebar extends React.Component<ChapterSidebarProps> {
  static defaultProps = {
    useUnorderedList: false,
  };

  constructor(props: ChapterSidebarProps) {
    super(props);
  }

  scrollTo = (e: React.MouseEvent) => {
    e.preventDefault();
    const index = (
      e.currentTarget as HTMLAnchorElement
    ).attributes.getNamedItem("data-index").value;
    const elementPosition = document.getElementById(index);
    if (elementPosition != null) {
      smoothScrollTo(document.getElementById(index), 85);
    }
  };

  renderListItem = () => {
    const { headings } = this.props;

    return isStringArray(headings)
      ? headings.map((heading, i) => {
          return (
            <li key={`chaptersidebar-${i}`}>
              <a
                role="button"
                href="#"
                onClick={this.scrollTo}
                data-index={i + 1}
                className="chapter-sidebar__link"
              >
                {heading}
              </a>
            </li>
          );
        })
      : !isStringArray(headings) &&
          headings.map((heading, i) => {
            return (
              heading && (
                <li key={`chaptersidebar-${i}`}>
                  <a className="chapter-sidebar__link" href={heading.Href}>
                    {heading.Title}
                  </a>
                </li>
              )
            );
          });
  };

  render() {
    const { useUnorderedList } = this.props;
    return (
      <nav
        className="chapter-sidebar__chapters"
        aria-label="Länklista av kapitel för denna sida"
      >
        {!useUnorderedList ? (
          <ol>{this.renderListItem()}</ol>
        ) : (
          <ul>{this.renderListItem()}</ul>
        )}
      </nav>
    );
  }
}
